import { render, staticRenderFns } from "./PartnersDataPending.vue?vue&type=template&id=5cd25bca&"
import script from "./PartnersDataPending.vue?vue&type=script&lang=ts&"
export * from "./PartnersDataPending.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports